import React, { useCallback, useState } from 'react';
import './BeneficiaryForm.scss';
import GlobalParams from '../../helpers/GlobalParams.js';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import { DataGrid, Column, CustomRule } from 'devextreme-react/data-grid';
import { Button, Lookup, TextBox, LoadPanel, DateBox, NumberBox, CheckBox, FileUploader } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper.js';
import LabelTemplate from '../../labels/LabelTemplate.js';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';
import notify from 'devextreme/ui/notify';

function BeneficiaryForm({ onClosePopup }) {

  const fetchBankBranch = async (bank_code) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-bank-branches-codes?bankCode=' + bank_code,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  var default_form = {
    Names: '',
    relationship: null,
    perc_alloc: null,
    birth_date: null,
    BirthCertificate: '',
    IDNumber: '',
    GuardianSurname: '',
    GuardianOtherNames: '',
    GuardianTelephone: '',
    GuardianEmail: '',
    PayMethod: '',
    Bank: '',
    BankBranch: '',
    BankAccount: '',
    BankAccountName: '',
    MobileNumber: '',
    //IsInstitution: 0,
    KRAPIN: '',

  }
  const [beneficiaryStore, setBeneficiaryStore] = useState(default_form);
  const [vsGuardian, setVsGuardian] = useState(false);
  const [vsBank, setVsBank] = useState(false);
  const [vsMpesa, setVsMpesa] = useState(false);
  const [vsIDNumber, setVsIDNumber] = useState(false);
  const [bankBranches, setBankBranches] = useState([]);

  const clear_form = () => {
    setBeneficiaryStore(default_form);
  }

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    // Now you can submit the combined data to your backend or perform any other actions
    console.log('Submitted data:', beneficiaryStore);
    clear_form();
    onClosePopup(beneficiaryStore);
    //postDependant(claimStore);
  }, [beneficiaryStore]);

  const calculateAge = (birthDate) => {
    const currentDate = new Date();
    const birthDateObj = new Date(birthDate);

    let age = currentDate.getFullYear() - birthDateObj.getFullYear();

    // Check if the birthday has occurred for this year
    if (currentDate.getMonth() < birthDateObj.getMonth() ||
      (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  };



  return (
    <div className="App">
      {isLoading && <LoadPanel visible={true} />}
      <br />
      <form onSubmit={doSave}>
        <Form
          formData={beneficiaryStore}>
          <GroupItem colCount={3} caption="">

            <Item
              colSpan={2}
              dataField="Names"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, Names: e.value });
                  }
                }
              }
            >
              <Label text='Name' />
            </Item>

            <Item
              dataField="relationship"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.RelationshipStore,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, relationship: e.value });
                  }
                }
              }
            >
              <RequiredRule message="Relationship" />
              <Label text='Relationship' />
            </Item>

            <Item
              dataField="KRAPIN"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, KRAPIN: e.value });
                  }
                }
              }
            >
              <Label text='KRA Pin' />
            </Item>

            <Item
              dataField="perc_alloc"
              editorType="dxNumberBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, perc_alloc: e.value });
                  }
                }
              }
            >
              <RequiredRule message="Percentage Allocated is Required" />
              <Label text='Percentage Allocated' />
            </Item>

            <Item
              dataField="birth_date"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, dob: e.value });
                    let tmp_age = calculateAge(e.value);
                    if (tmp_age < 18) {
                      setVsGuardian(true);
                      setVsIDNumber(false);
                    }else{
                      setVsGuardian(false);
                      setVsIDNumber(true);
                    }
                  }
                }
              }
            >
              <Label text='Date of Birth' />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <Item
              dataField="IDNumber"
              visible={vsIDNumber}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, IDNumber: e.value });
                  }
                }
              }
            >
              <RequiredRule message="ID Number is Required" />
              <Label text='ID Number' />
            </Item>

            <Item
              colSpan={2}
              dataField="BirthCertificate"
              editorType="dxTextBox"
              visible={vsGuardian}
              editorOptions={
                {

                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, BirthCertificate: e.value });
                  }
                }
              }
            >
              {vsGuardian && <RequiredRule message="Birth Certificate Number is required" />}
              <Label text='Birth Certificate Number' />
            </Item>

            <Item
              dataField="GuardianSurname"
              editorType="dxTextBox"
              visible={vsGuardian}
              editorOptions={
                {

                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, GuardianSurname: e.value });
                  }
                }
              }
            >
              {vsGuardian && <RequiredRule message="Guardian Surname is required" />}
              <Label text='Guardian Surname' />
            </Item>

            <Item
              dataField="GuardianOtherNames"
              editorType="dxTextBox"
              visible={vsGuardian}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, GuardianOtherNames: e.value });
                  }
                }
              }
            >
              {vsGuardian && <RequiredRule message="Guardian Othernames is required" />}
              <Label text='Guardian Other Names' />
            </Item>

            <Item
              dataField="GuardianTelephone"
              visible={vsGuardian}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, GuardianTelephone: e.value });
                  }
                }
              }
            >
              {vsGuardian && <RequiredRule message="Guardian Telephone is required" />}
              <Label text='Guardian Telephone' />
            </Item>

            <Item
              dataField="GuardianEmail"
              visible={vsGuardian}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, GuardianEmail: e.value });
                  }
                }
              }
            >
              <Label text='Guardian Email' />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <Item
              dataField="PayMethod"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.ClaimPaymentMethods,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, PayMethod: e.value });
                    //TODO - Get the Bank Branches...
                    /*setVsBank(false);
                    setVsMpesa(false);
                    if (e.value === '100' || e.value === '300' || e.value === '400') {
                      console.log(e.value);
                      setVsBank(true);
                    } else if (e.value === '200') {
                      setVsMpesa(true);
                    }*/
                    setVsBank(false);
                    setVsMpesa(false);
                    if (e.value === '1') {
                      console.log(e.value);
                      setVsBank(true);
                    } else if (e.value === '2') {
                      setVsMpesa(true);
                    }


                  }
                }
              }
            >
              <RequiredRule message="Pay Method is Required" />
              <Label text='Pay Method' />
            </Item>

            <Item
              colSpan={2}
              dataField="Bank"
              editorType="dxLookup"
              visible={vsBank}
              editorOptions={
                {
                  dataSource: GlobalParams.Banks,
                  displayExpr: "description",
                  valueExpr: "bank_code",
                  searchEnabled: true,
                  onValueChanged: async (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, Bank: e.value });
                    //TODO - fech the bank branches..
                    setIsLoading(true);
                    let tmp_bankBranch = await fetchBankBranch(e.value);
                    setBankBranches(tmp_bankBranch);
                  }
                }
              }
            >
              {vsBank && <RequiredRule message="Bank is required" />}
              <Label text='Bank' />
            </Item>

            <Item
              colSpan={2}
              dataField="BankBranch"
              editorType="dxLookup"
              visible={vsBank}
              editorOptions={
                {
                  dataSource: bankBranches,
                  displayExpr: "bankBranchName",
                  valueExpr: "id",
                  searchEnabled: true,
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, BankBranch: e.value });
                  }
                }
              }
            >
              {vsBank && <RequiredRule message="Bank is required" />}
              <Label text='Bank Branch' />
            </Item>

            <Item
              dataField="BankAccount"
              editorType="dxTextBox"
              visible={vsBank}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, BankAccount: e.value });
                  }
                }
              }
            >
              {vsBank && <RequiredRule message="Bank is required" />}
              <Label text='Bank Account' />
            </Item>
            {/*claimant*/}

            <Item
              dataField="BankAccountName"
              editorType="dxTextBox"
              visible={vsBank}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, BankAccountName: e.value });
                  }
                }
              }
            >
              {vsBank && <RequiredRule message="Bank Account Name is required" />}
              <Label text='Bank Account Name' />
            </Item>

            <Item
              dataField="MobileNumber"
              editorType="dxTextBox"
              visible={vsMpesa}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setBeneficiaryStore({ ...beneficiaryStore, MobileNumber: e.value });
                  }
                }
              }
            >
              {vsMpesa && <RequiredRule message="Mobile Number is required" />}
              <Label text='MPesa Number' />
            </Item>





            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />


            <ButtonItem
              colSpan={3}
            >
              <ButtonOptions type='default' text="SUBMIT" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );
}
export default BeneficiaryForm;